import React, { useEffect, useState } from "react";
import axios from "axios";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "../index.css";

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [loading, setLoading] = useState(true);

  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    axios
      .get("https://online.funforay.com/admin/public/api/gallery")
      .then((res) => {
        if (res.data.status) {
          setGallery(res.data.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  return (
   <section className="ff-gallery-section">
    <div className="">

        <div className="ff-gallery-heading">
            <span className="gallery_title">Our Memories</span>
            <h2>Recent Gallery</h2>
        </div>

        <div className="ff-masonry-gallery">
  {gallery.map((item, index) => (
    <div
      className="ff-gallery-box"
      key={item.id}
      onClick={() => {
        setPhotoIndex(index);
        setIsOpen(true);
      }}
    >
      <img
        src={item.image}
        alt=""
        className="ff-gallery-img"
      />
    </div>
  ))}
</div>

{isOpen && (
  <Lightbox
    mainSrc={gallery[photoIndex].image}
    nextSrc={gallery[(photoIndex + 1) % gallery.length].image}
    prevSrc={
      gallery[(photoIndex + gallery.length - 1) % gallery.length].image
    }
    onCloseRequest={() => setIsOpen(false)}
    onMovePrevRequest={() =>
      setPhotoIndex(
        (photoIndex + gallery.length - 1) % gallery.length
      )
    }
    onMoveNextRequest={() =>
      setPhotoIndex(
        (photoIndex + 1) % gallery.length
      )
    }
  />
)}

    </div>
</section>
  );
};

export default Gallery;